export enum HTLookUps {
	FURNISH_STATUS = "FurnishingStatuses",
	PROPERTY_CONDITIONS = "PtPropertyConditions",
	FINALIZED_REQUIREMENTS = "PtFinalizedRequirements",
	ATTACHMENTS = "PhPtAttachments",
}

export enum HTDocType {
	DAMAGES = "57",
	REJECT = "58",
	HANDOVER = "59",
}
